import React from 'react'
import FeatureSection from '../components/FeatureSection'

function ReviewsUnlock() {
  return (
    <FeatureSection
      title="Effortlessly increase 5-star reviews"
      description="You can collect customer reviews for your business on platforms like Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers."
      image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f5137d8481966af958cfec_Group%201000005190%20(2).png"
      reverse={false}
      eyebrow={"Reviews"}
      showEyebrow={true}
    />
  //   <div className="w-full bg-white py-20">
  //   <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row-reverse items-center gap-12">
  //     <div className="flex-1">
  //       <p className="text-[#7f56d9] font-semibold text-sm mb-3">Reviews</p>
  //       <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
  //         Effortlessly increase 5-star reviews
  //       </h2>
  //       <p className="text-gray-600 text-lg mb-8">
  //         You can collect customer reviews for your business on platforms like
  //         Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers.
  //       </p>

  //       <div className="flex gap-4">
  //         <button className="border border-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-md hover:bg-gray-100">
  //           Book a demo
  //         </button>
  //         <button className="bg-[#7f56d9] hover:bg-[#6c4cc2] text-white font-semibold py-3 px-6 rounded-md">
  //           Get Started
  //         </button>
  //       </div>
  //     </div>

  //     <div className="flex-1 flex justify-center relative">
  //       <div className="bg-[#f9f9fb] p-8 rounded-2xl w-[540px] h-[480px] flex items-center justify-center relative overflow-hidden">
  //         <img
  //           src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f5137d8481966af958cfec_Group%201000005190%20(2).png"
  //           alt="Phone Mockup 1"
  //           className="w-[240px] "
  //         />
  //       </div>
  //     </div>
  //   </div>
  // </div>
  )
}

export default ReviewsUnlock